export default function getAccountsFromMe(meData, options = {}) {
	let accounts = meData.accounts;
	accounts.forEach(account => {
		account.currentAccount = account.id === meData.current_account_id;
	});

	let organizations = meData.organizations ?? [];
	accounts.forEach(account => {
		account.organization = organizations.find(org => org.id === account.organization_id);
		if(account.organization?.parent_organization_id) {
			account.organization.parent_organization = organizations.find(org => org.id === account.organization.parent_organization_id);
		}
	});
	accounts.sort((a, b) => {
		let mainOrgCompare = (a.organization.name?.toLowerCase() ?? '').localeCompare(b.organization.name?.toLowerCase() ?? '');

		// If main orgs are exactly the same sort by parent org (ie: two Painted Rock Elementary sort by studio name instead)
		if(mainOrgCompare === 0) {
			if(a.organization.parent_organization && b.organization.parent_organization) {
				return (a.organization.parent_organization.name?.toLowerCase() ?? '').localeCompare(b.organization.parent_organization.name?.toLowerCase() ?? '');
			}
		}

		return mainOrgCompare;
	});

	if(options.filterBySlug) {
		accounts = accounts.filter(account => account.enable_plic_app_whitelist === false || account.plic_app_whitelist_slugs.includes(options.filterBySlug));
	}

	return accounts;
}